import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10f34c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title track-title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "flex mb_20" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "flex dashed" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "log" }
const _hoisted_11 = {
  key: 0,
  class: "log-line"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "log-line-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_13 = { class: "log-line-content flex" }
const _hoisted_14 = { class: "log-line-item states mr_10" }
const _hoisted_15 = { class: "log-line-item date" }
const _hoisted_16 = {
  class: "log-line-item",
  style: {"margin-left":"38px"}
}
const _hoisted_17 = {
  key: 1,
  style: {"line-height":"22px"}
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 該当の運送会社のステータスは同期されないため、お手数ですが、 ")
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" から進捗状況をご確認ください ")

import { t } from '@/plugins/i18n'
import { ref, watch, computed } from 'vue'
import { deliveryTypeDict } from '../data'
import { getJapanTime } from '@/util/common'
import dayjs from 'dayjs'
import { getTranslationText } from '@/apis/common'
import { expressCostPdf, isJA } from '@/store'
import { template } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => { }
  },
  isJPWorder: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props


console.log(props.rowItem.value, 'rowItem')

const list: any = computed(() => props.rowItem?.taskTrackDTOList ?? [])
// const noFound: any = computed(() => props.noFound)

// watch(rowItem, (v) => {
//   Promise.all((v?.taskTrackDTOList ?? []).map((v: any) => {
//     const formData = {
//       from: 'zh',
//       to: 'ja',
//       text: v.message
//     }
//     return getTranslationText(formData).then(res => {
//       return {
//         ...v,
//         message: res.success ? res.data : v.message
//       }
//     })
//   })).then(res => {
//     list.value = res.reverse()
//   })
// })

const dateDict: any = {
  0: t('星期日'),
  1: t('星期一'),
  2: t('星期二'),
  3: t('星期三'),
  4: t('星期四'),
  5: t('星期五'),
  6: t('星期六')
}

const showDay = (date: any) => {
  const num = dayjs(date).day()
  return dateDict[num]
}



return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('物流详情')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('发货类型')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_unref(deliveryTypeDict)[__props.rowItem?.deliveryType] ?? ''), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(__props.isJPWorder ? '日本国内配送依赖番号' : _unref(t)('国际发货单号')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(__props.rowItem?.deliveryTaskCode ?? ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('运输方式')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(__props.rowItem?.shippingType ?? ''), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('运单号')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(__props.rowItem?.logisticsCode ?? ''), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_unref(list)?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (v) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "log-line-info flex",
                    key: v.date
                  }, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(showDay(_unref(getJapanTime)(v.date))), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(getJapanTime)(v.date)), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(v?.message ?? ''), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (!_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('該当物流会社のステータスは表記できないため、お手数ですが、下記参考ファイルに追跡URLをご確認くださいませ')), 1),
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_unref(t)('参考ファイル：')) + " ", 1),
                        _createElementVNode("a", {
                          href: _unref(expressCostPdf)(),
                          target: "_blank"
                        }, _toDisplayString(_unref(t)('国際送料')), 9, _hoisted_19)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (!__props.isJPWorder)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_21,
                            _createElementVNode("a", {
                              target: "_blank",
                              href: __props.rowItem?.shipInfo?.officialWebsiteLink || _unref(expressCostPdf)()
                            }, "公式サイト", 8, _hoisted_22),
                            _hoisted_23
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})